import { render, staticRenderFns } from "./ClienteCompleto.vue?vue&type=template&id=c19e12e0&scoped=true"
import script from "./ClienteCompleto.vue?vue&type=script&lang=js"
export * from "./ClienteCompleto.vue?vue&type=script&lang=js"
import style0 from "./ClienteCompleto.vue?vue&type=style&index=0&id=c19e12e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19e12e0",
  null
  
)

export default component.exports